export const M2_IN_KM2 = 1_000_000;
export const M2_IN_HA = 10_000;

export const M2_TO_FT2 = 10.7639104;
export const M2_TO_MI2 = 0.00000038610;
export const M2_TO_ACRE = 0.00024711;
export const M2_TO_HA = 1 / M2_IN_HA;
export const M2_TO_KM2 = 1 / M2_IN_KM2;
export const HA_TO_ACRE = 2.4711;
export const FT2_TO_M2 = 1 / M2_TO_FT2;
export const ACRE_TO_HA = 1 / HA_TO_ACRE;

export const M_IN_KM = 1_000;
export const FT_IN_MI = 5_280;
export const ACRE_IN_MI = 640;

export const M_TO_FT = 1.09361 * 3;
export const M_TO_MI = 0.000621371;
export const M_TO_KM = 1 / M_IN_KM;
export const FT_TO_M = 1 / M_TO_FT;

export const ACRE_TO_FT2 = 43560;
export const FT2_TO_ACRE = 1 / ACRE_TO_FT2;


export class Quantity {

    constructor(readonly value: number, readonly unit: string) {}

    toString() {
        return `${this.value.toFixed(2)} ${this.unit}`;
    }
}


export class Area {

    constructor(readonly m2: number) {}

    getQuantity(imperial = false): Quantity {
        if (imperial) {
            // When area is larger than 1 mile, show miles
            if (this.m2 * M2_TO_ACRE >= ACRE_IN_MI) {
                return new Quantity(this.m2 * M2_TO_MI2, 'mi²');
            }
            if (this.m2 * M2_TO_ACRE >= 1) {
                return new Quantity(this.m2 * M2_TO_ACRE, 'acres');
            }
            return new Quantity(this.m2 * M2_TO_FT2, 'ft²');
        }
        if (this.m2 >= M2_IN_KM2) {
            return new Quantity(this.m2 * M2_TO_KM2, 'km²');
        }
        if (this.m2 >= M2_IN_HA) {
            return new Quantity(this.m2 * M2_TO_HA, 'ha');
        }
        return new Quantity(this.m2, 'm²');
    }
}


export class Distance {

    constructor(readonly m: number) {}

    getQuantity(imperial = false): Quantity {
        if (imperial) {
            if (this.m * M_TO_FT >= FT_IN_MI) {
                return new Quantity(this.m * M_TO_MI, 'mi');
            }
            return new Quantity(this.m * M_TO_FT, 'ft');
        }
        if (this.m >= M_IN_KM) {
            return new Quantity(this.m * M_TO_KM, 'km');
        }
        return new Quantity(this.m, 'm');
    }
}
